import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useAdStudioNavigationStyle = makeStyles({
  customTabItem: {
    width: '100%',
  },
  tabItemWrapper: {
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '6px',
    paddingRight: '6px',
    '&.selected': {
      backgroundColor: '#ebebeb',
      ...shorthands.borderRadius('8px'),
    },
  },
  adStudioNavigation: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: '32px',
    width: '266px',
    backgroundColor: tokens.colorNeutralBackground2,
    ...shorthands.padding('8px', '8px', '24px', '8px'),
    overflowY: 'auto',
    zIndex: 1,
    '& .side-navigation-more-button': {
      display: 'none',
    },
  },
  placeholder: {
    position: 'absolute',
    bottom: 0,
    width: '266px',
    height: '32px',
    backgroundColor: tokens.colorNeutralBackground2,
    zIndex: -1,
  },
  divider: {
    marginTop: '6px',
    marginBottom: '6px',
    marginLeft: '8px',
    marginRight: '8px',
  },
  dividerContent: {
    '&::before': {
      content: '""',
      display: 'flex',
      flexGrow: 1,
      minWidth: '8px',
      ...shorthands.borderTop('1px', 'solid', '#E0E0E0'),
    },
  },
});

export const useFoldersTreeViewStyle = makeStyles({
  flatTree: {
    '&.fui-FlatTree': {
      rowGap: 0,
    },
  },
  tabItemWrapper: {
    '& button': {
      width: '100%',
    },
  },
  treeItemLayout: {
    '&.fui-TreeItemLayout': {
      lineHeight: '20px',
      minHeight: '20px',
      '&:active': {
        backgroundColor: '#e0e0e0 !important',
      },
    },
    '& .fui-TreeItemLayout__main': {
      overflowX: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  tooltipHost: {
    display: 'inline-block',
    width: '100%',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  treeSelected: {
    fontWeight: 'bold',
  },
  customDropDecorator: {
    outlineOffset: '-2px',
    outlineStyle: 'dashed',
    outlineWidth: '2px',
    outlineColor: tokens.colorBrandBackground,
  },
});
